import React, { useState } from 'react';
import { Box, Modal, ModalFooter, ModalHeader, TextField } from '@parspec/pixel';

import { useAddFoldersForProject } from 'src/features/Project/queries';


interface IRenameModalProps {
    open: boolean;
    onClose: () => void;
    onCreateFolderSuccess: () => void;
    projectId: number;
}

const AddFolderModal = (props: IRenameModalProps) => {
    const { open, projectId, onClose, onCreateFolderSuccess } = props;

    const { mutateAsync: addFoldersForProject, isLoading: isCreatingFolder } = useAddFoldersForProject();
    const [folderName, setFolderName] = useState<string>("");
    const [error, setError] = useState<string | null>(null);

    const handleConfirmClicked = async () => {
        const trimmedName = folderName.trim();
        if (!trimmedName) {
            setError('Required');
            return;
        }

        try {
            await addFoldersForProject({ projectId, payload: { name: trimmedName } });
            onCreateFolderSuccess();
            onClose();
        } catch (error) { }
    };

    const header = <ModalHeader title="Create Folder" onClose={onClose} />;
    const footer = (
        <ModalFooter
            onReject={onClose}
            onAccept={handleConfirmClicked}
            continueButtonLabel="Confirm"
            cancelButtonLabel="Cancel"
            isLoading={isCreatingFolder}
        />
    );

    const handleFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFolderName(e.target.value);
        setError(null);
    };


    return (
        <Modal header={header} footer={footer} open={open}>
            <Box width={480}>
                <TextField
                    disabled={isCreatingFolder}
                    label="Folder Name"
                    onChange={handleFileNameChange}
                    value={folderName}
                    helperText={error}
                    error={!!error}
                />
            </Box>
        </Modal>
    );
};

export default AddFolderModal;
